module.exports = {
  watchdog: {
    entitySave:'save',
    languages: {
      en: 'English',
      nl: 'Nederlands',
      fr: 'Francais'
    },
    title:{
      text:'Watchdog',
      info:'Watchdog is an Onsophic service which monitor the state of each all the different Onsophic services.'
    },
    alert:{
      warning:{
        title:'Holy guacamole!',
        info:'We are currently facing trouble on some of the services, we are working on the solution. check the log for more information.'
      },
      normal:{
        title:'Relax!',
        info:'All systems are up and running, you are good to go.'
      },
      maintenance:{
        title:'Maintenance!',
        info:'The servers are under maintenance, please check the log for more information.'
      },
      critical:{
        title:'Oops!',
        info:'It seems like some systems are experiencing issues, we are working on the solution. Please check the log for more information.'
      },
      editMessage:{
        title:'Edit message',
        state:'State',
        message:'Message'
      }
    },
    statistics:{
      title:"STATISTICS",
      responsetime:{
        title:"Response time",
        average:"Average"
      }
    },
    services:{
      title:"SERVICES",
      eventprocessing:{
        title:"Event processor",
        info:"Shows whether stats are being generated"
      },
      api:{
        title:"API",
        info:"Shows whether users are able to log in"
      },
      webapp:{
        title:"Web application",
        info: "Shows whether users are able to reach the Onsophic web page"
      },
      notavailable:"Not available",
      edit:{
        automatic:"Automatic",
        manual:"Manual"
      }
    },
    statushistory:{
      title:"STATUS HISTORY",
      noAnnouncements:"No announcements",
      addAnnouncement:"add announcement",
      announcement:{
        title:"Title",
        services:"Services",
        message:"Message",
        state:"State",
        addChild:"add child",
        history:"HISTORY"
      }
    },
    login:{
      login:"login",
      username:"username",
      password:"password"
    }
  }
};




/** WEBPACK FOOTER **
 ** ./src/languages/en.js
 **/